import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold mb-4 mt-5" }, " Información de Contacto ", -1)
const _hoisted_2 = { class: "px-4 py-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Nombre:"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "Mesa de ayuda Brics21")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Teléfono:"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "123-456-7890")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Email:"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "info@brics21.cl")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold w-25" }, "Dirección:"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-start" }, "Valparaiso, Limache 3405, El Salto")
], -1)
const _hoisted_7 = { class: "flex my-4" }
const _hoisted_8 = { class: "p-4" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = { class: "px-4 py-2 rounded-md bg-primary text-white hover:bg-green-600 focus:bg-green-600" }
const _hoisted_12 = {
  key: 1,
  class: "icon-spin"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ComponentCard = _resolveComponent("ComponentCard")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalAlertResolved = _resolveComponent("ModalAlertResolved")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ComponentCard, { class: "w-[330px] h-[270px] pointer transition shadow-xl border rounded-xl" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "flex bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showWriteMeModal && _ctx.showWriteMeModal(...args)))
            }, " Escríbenos ")
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      title: "Escribenos",
      visible: _ctx.showWriteMe,
      "onUpdate:visible": _cache[6] || (_cache[6] = (e) => _ctx.showWriteMe = e)
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, [
            _createVNode(_component_TextField, {
              label: "Nombre",
              model: _ctx.name,
              "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              type: "text",
              name: "cargo"
            }, null, 8, ["model"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_TextField, {
              label: "Telefono",
              model: _ctx.phone,
              "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.phone) = $event)),
              type: "text",
              name: "telefono"
            }, null, 8, ["model"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_TextField, {
              label: "Correo",
              model: _ctx.email,
              "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.email) = $event)),
              type: "email",
              name: "email"
            }, null, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_TextField, {
              label: "Mensaje",
              model: _ctx.message,
              "onUpdate:model": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
              type: "textarea",
              name: "mensaje"
            }, null, 8, ["model"])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", _hoisted_11, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openModalSend && _ctx.openModalSend(...args)))
                }, "Enviar Mensaje"))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    (_ctx.showModalAlert)
      ? (_openBlock(), _createBlock(_component_ModalAlertResolved, {
          key: 0,
          type: 'success',
          message: 'Se ha enviado un mensaje al correo señalado',
          title: 'Correo Enviado',
          visible: _ctx.showModalAlert,
          onAccept: _ctx.sendMail
        }, null, 8, ["visible", "onAccept"]))
      : _createCommentVNode("", true)
  ]))
}